module.exports = __webpack_public_path__ + "media/site/images/startups/skilldepository-tablet-db7c06b4fcfca1586c2cd8090703a4a2.png";